/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TherapyMedicationChangeDtoTherapyPhase =
  (typeof TherapyMedicationChangeDtoTherapyPhase)[keyof typeof TherapyMedicationChangeDtoTherapyPhase];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TherapyMedicationChangeDtoTherapyPhase = {
  PHASE_1: 'PHASE_1',
  PHASE_2: 'PHASE_2',
} as const;
